var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-progress__wrapper"},[_c('div',{staticClass:"step-progress__wrapper-before",style:({'background-color': _vm.passiveColor, height: _vm.lineThickness + 'px'})}),_c('div',{staticClass:"step-progress__bar"},_vm._l((_vm.steps),function(step,index){return _c('div',{class:[
        'step-progress__step',
        { 'step-progress__step--valid': index < _vm.currentStep },
        { 'step-progress__step--active-not-process':  (index === _vm.currentStep && !_vm.isProcessing) },
        { 'step-progress__step--active':  (index === _vm.currentStep && _vm.isProcessing) },
        { 'blink-active': _vm.blinkActive && index === _vm.currentStep }
      ],style:({
        '--activeColor': _vm.activeColor,
        '--currentStepColor': _vm.currentStepColor || _vm.activeColor,
        '--passiveColor': _vm.passiveColor,
        '--activeBorder': _vm.activeThickness + 'px',
        '--passiveBorder': _vm.passiveThickness + 'px'
      }),on:{"mouseenter":function($event){_vm.showStepOnHover ? _vm.setHoveredStep(index) : null},"mouseleave":function($event){_vm.showStepOnHover ? _vm.setHoveredStep(null) : null}}},[_c('span',{class:[{ 'blink-animation': _vm.blinkActive && index === _vm.currentStep }]},[_vm._v(_vm._s(index + 1))]),_c('div',{staticClass:"step-progress__step-icon",class:[
          { [_vm.iconClass]: index < _vm.currentStep || (index === _vm.currentStep && !_vm.currentIconClass) },
          { [_vm.currentIconClass]: (index === _vm.currentStep && _vm.currentIconClass)}
        ]}),(_vm.showStepOnHover)?[(_vm.hoveredStep === index)?_c('div',{class:[
            'step-progress__bubble',
            {
              'step-progress__bubble--first': index === 0,
              'step-progress__bubble--last': index === _vm.steps.length - 1,
              'step-progress__bubble--middle': index > 0 && index < _vm.steps.length - 1
            }
          ]},[_vm._v(" "+_vm._s(step)+" ")]):_vm._e()]:[(!_vm.showStatusInBubble)?_c('div',{staticClass:"step-progress__step-label"},[_vm._v(_vm._s(step))]):_vm._e(),(index === _vm.getBubblePointTo(_vm.currentStep) && (_vm.showStatusInBubble || _vm.bubbleText))?_c('div',{class:[
            'step-progress__bubble',
            {
              'step-progress__bubble--first': index === 0,
              'step-progress__bubble--last': index === _vm.steps.length - 1,
              'step-progress__bubble--middle': index > 0 && index < _vm.steps.length - 1
            }
          ]},[(_vm.bubbleText)?[_vm._v(" "+_vm._s(_vm.bubbleText)+" ")]:[_vm._v(" "+_vm._s(step)+" ")]],2):_vm._e()]],2)}),0),_c('div',{staticClass:"step-progress__wrapper-after",style:({
      transform: 'scaleX(' + _vm.scaleX + ') translateY(-50%) perspective(1000px)',
      'background-color': _vm.activeColor,
      height: _vm.lineThickness + 'px'
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }